import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import ErrorBoundary from "../../lib/classes/ErrorBoundary";
import gridBox from "./gridBox";
import ProductCard from "./ProductCard/ProductCard";
import ZeroCard from "./ZeroCard";

const GridViewAll = () => {
  const { creditListing } = useSelector((store) => store.credits);

  return (
    <ErrorBoundary>
      {creditListing.length > 0 ? (
        creditListing.map((credit) => (
          <ProductCard key={credit.id} credit={credit} />
        ))
      ) : (
        <Box component="span" sx={gridBox}>
          <ZeroCard />
        </Box>
      )}
    </ErrorBoundary>
  );
};

export default GridViewAll;
